import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { FeatureStateSymbol, IAppWillMountHandler } from '@wix/thunderbolt-symbols'
import { IWarmupDataProvider, WarmupDataProviderSymbol } from 'feature-warmup-data'
import { IFeatureState } from 'thunderbolt-feature-state'
import type { ExternalComponentWarmupData, ExternalComponentSecondPhaseRenderComponentIds } from './types'
import { name } from './symbols'

export default withDependencies<IAppWillMountHandler>(
	[WarmupDataProviderSymbol, named(FeatureStateSymbol, name)],
	(
		warmupDataProvider: IWarmupDataProvider,
		featureState: IFeatureState<ExternalComponentSecondPhaseRenderComponentIds>
	) => ({
		appWillMount: async () => {
			const externalComponentWarmupData = await warmupDataProvider.getWarmupData<ExternalComponentWarmupData>(
				'externalComponent'
			)

			const failedInSsr =
				!externalComponentWarmupData?.failedInSsr ||
				Object.keys(externalComponentWarmupData?.failedInSsr).length === 0
					? null
					: { ...externalComponentWarmupData?.failedInSsr }
			featureState.update((state) => ({ ...state, failedInSsr }))

			externalComponentWarmupData?.ssrErrors.forEach((error) => {
				console.error(`External component failed on SSR: ${error}`)
			})
		},
	})
)
